module.exports = __webpack_public_path__ + "fonts/9dce7f0.eot";